import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Flex, Box, Grid } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import { Slider } from '@reach/slider'
import '@reach/slider/styles.css'

export enum GoalSettingType {
  liveLesson = 'liveLesson',
  selfStudy = 'selfStudy',
}

const StyledSlider = styled(Slider)`
  cursor: pointer;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  width: 100% !important;
  max-width: 100%;
  margin-top: -4px;
  [data-reach-slider-track][data-orientation='horizontal'] {
    background: ${(props) => props.theme.colors.gray95};
    height: 8px;
    border-radius: 10px;
  }
  [data-reach-slider-handle] {
    height: 32px;
    width: 32px;
    border-radius: 100%;
    border-color: ${(props) => props.theme.colors.yellow65};
  }
  [data-reach-slider-track-highlight] {
    background: ${(props) => props.theme.colors.yellow65};
  }
`

const getGoalSettingInfo = (type: GoalSettingType) => {
  return {
    selfStudy: {
      min: 10,
      max: 420,
      step: 10,
      title: t('Study minutes per week'),
    },
    liveLesson: { min: 1, max: 14, step: 1, title: t('Live Lessons per week') },
  }[type]
}

export type Props = {
  type: GoalSettingType
  goalValue?: number
  onChange?: (value: number) => void
}

const GoalSlider: React.FC<Props> = ({ type, goalValue, onChange }) => {
  const goalSettingInfo = getGoalSettingInfo(type)
  const [value, setValue] = useState(goalValue || goalSettingInfo.min)

  useEffect(() => {
    if (goalValue && goalValue !== value) {
      setValue(goalValue)
    }
  }, [value, setValue, goalValue])

  const handleChange = (newValue: number) => {
    if (onChange) {
      onChange(newValue)
    } else {
      setValue(newValue)
    }
  }
  return (
    <Grid columns="1fr" gridGap="2x">
      <Box as="p" variant="text.h5">
        {goalSettingInfo.title}
      </Box>
      {/* a large grid-gap to prevent the handle from overlapping with the gap between elements on the min setting */}
      <Grid columns="55px 1fr" gridGap="3x" alignItems="center" height="36px">
        <Flex
          justifyContent="center"
          alignItems="center"
          borderWidth="small"
          borderStyle="solid"
          borderColor="gray88"
          borderRadius="24px"
          py="0,25x"
        >
          {value}
        </Flex>
        <StyledSlider
          min={goalSettingInfo.min}
          max={goalSettingInfo.max}
          step={goalSettingInfo.step}
          value={value}
          onChange={handleChange}
          getAriaLabel={() => goalSettingInfo.title}
        />
      </Grid>
    </Grid>
  )
}

export default GoalSlider
